import React, { useState } from 'react';
import { Box, Button, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const isInstagramAndroid = /Instagram/.test(navigator.userAgent) && /Android/.test(navigator.userAgent);

const InstagramBrowserBanner = () => {
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem('igBannerDismissed') === '1'
  );

  if (!isInstagramAndroid || dismissed) return null;

  const handleDismiss = () => {
    sessionStorage.setItem('igBannerDismissed', '1');
    setDismissed(true);
  };

  const handleOpenInChrome = () => {
    const url = window.location.href;
    window.location.href = `intent://${url.replace(/^https?:\/\//, '')}#Intent;scheme=https;package=com.android.chrome;end`;
  };

  return (
    <Box
      sx={{
        bgcolor: '#4a1350',
        color: 'white',
        px: 2,
        py: 0.75,
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        flexShrink: 0,
      }}
    >
      <Typography variant="caption" sx={{ flex: 1, lineHeight: 1.4 }}>
        Opens slowly in Instagram? Tap to load in Chrome.
      </Typography>
      <Button
        size="small"
        variant="outlined"
        color="inherit"
        onClick={handleOpenInChrome}
        endIcon={<OpenInNewIcon sx={{ fontSize: '0.85rem !important' }} />}
        sx={{
          fontSize: '0.7rem',
          py: 0.25,
          px: 1,
          minWidth: 0,
          borderColor: 'rgba(255,255,255,0.5)',
          whiteSpace: 'nowrap',
          flexShrink: 0,
        }}
      >
        Open in Chrome
      </Button>
      <IconButton
        size="small"
        color="inherit"
        onClick={handleDismiss}
        sx={{ p: 0.25, flexShrink: 0 }}
        aria-label="Dismiss"
      >
        <CloseIcon sx={{ fontSize: '1rem' }} />
      </IconButton>
    </Box>
  );
};

export default InstagramBrowserBanner;
